/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetAllEntityLookups = require('../../common/services/GetAllEntityLookups');
var GetEvent = require('../services/GetEvent');

var COCEditEventVenueDetailsView = require('../views/COCEditEventVenueDetailsView');

module.exports = function(eventId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetAllEntityLookups(), GetEvent(eventId))
    .done(function(lookups, event) {
      NavUtils.navigate('coc/event/' + eventId + '/edit-venue');

      Scaffold.content.show(
        new COCEditEventVenueDetailsView({
          model: new Backbone.Model({
            entityTypes: lookups.entityTypes,
            organizationTypes: lookups.organizationTypes,
            venueId: event.venue.id,
            contactId: event.venue.contactId,
            venueAddress: event.venue.address,
            event: {
              eventId: event.id,
              eventTitle: event.eventTitle,
              venueName: event.venue.name,
              venueAddress: event.venue.fullAddress,
              venueContactName:
                event.venue.contactFirstName || event.venue.contactLastName
                  ? event.venue.contactFirstName + ' ' + event.venue.contactLastName
                  : null,
              venuePhone: event.venue.contactPhone,
              venueEmail: event.venue.contactEmail,
              eventFormatId: event.eventFormatId
            }
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
